import React from 'react';

interface UseDisclosureProps {
  initialState?: boolean;
}

export const useDisclosure = ({ initialState = false }: UseDisclosureProps = {}) => {
  const [isOpen, setIsOpen] = React.useState(initialState);

  const open = React.useCallback(() => setIsOpen(true), [setIsOpen]);
  const close = React.useCallback(() => setIsOpen(false), [setIsOpen]);
  const toggle = React.useCallback(() => setIsOpen(!isOpen), [isOpen, setIsOpen]);

  return React.useMemo(
    () => ({
      isOpen,
      open,
      close,
      toggle,
    }),
    [isOpen, open, close, toggle],
  );
};
